import { Model } from '@vuex-orm/core';
import { Company, Location } from './models';
import { uuidv4 } from '../../utils/helpers';

export class Warehouse extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'warehouses';

  static fields() {
    return {
      id: this.attr(() => uuidv4()),
      company_id: this.attr(null),
      company: this.belongsTo(Company, 'company_id'),
      name: this.attr(null),
      license_no: this.attr(null),
      keeper_no: this.attr(null),
      location_id: this.attr(null),
      location: this.belongsTo(Location, 'location_id'),
      updated_at: this.attr(null),
      created_at: this.attr(null),
    };
  }
}

export default Warehouse;
